import(/* webpackMode: "eager" */ "/root/repo/src/app/score-check/experience/page.tsx");
